module.exports = __webpack_public_path__ + "d38bdb7dbd0f8c8a5270b71b724409df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/assets/icons/icon.svg
// module id = 56
// module chunks = 0